// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wDaR","right":"styles_right__1D87t"};